import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { IRREGULARITIES_NOTES_MAX_LENGTH } from 'shared/constants';
import { ValidationService } from 'shared/services';
import { newline2br } from 'shared/helpers';
import { Textarea, Modal, AlertNotice } from 'shared/components';
import isEmpty from 'lodash/isEmpty';

class IrregularityNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      irregularity: props.irregularity,
      error: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onCancelIrregularity = this.onCancelIrregularity.bind(this);
    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    const { value } = e.target;

    if (value && !ValidationService.specialCharsPermissive(value)) {
      this.setState({
        error: 'errors.specialCharactersNotAllowed2',
      });
      return;
    }

    this.setState((prevState) => ({
      irregularity: {
        ...prevState.irregularity,
        notes: value,
      },
      error: '',
    }));
  }

  onToggleModal() {
    this.setState((prevState) => ({
      modalIsOpen: !prevState.modalIsOpen,
    }));
  }

  onCancelIrregularity() {
    this.onToggleModal();
    this.props.onCancel();
  }

  onSubmit() {
    const { irregularity } = this.state;

    if (!irregularity.notes) {
      this.setState({
        error: 'errors.notesRequired',
      });
      return;
    }

    this.props.onContinue(irregularity, true);
  }

  render() {
    const { irregularity } = this.state;

    return (
      <section className="irregularity-notes">
        <h4>{irregularity.irregularityType.irregularityCategory.name}</h4>
        <p className="mb-4">{irregularity.irregularityType.name}</p>
        <Textarea
          name="notes"
          label={this.props.t('common.labels.notes')}
          value={irregularity.notes}
          onChange={this.onChange}
          maxLength={IRREGULARITIES_NOTES_MAX_LENGTH}
          error={this.state.error}
        />
        <h5 className="mt-3 mb-2">{this.props.t('irregularities.instructions')}</h5>
        <p
          className="mb-3"
          dangerouslySetInnerHTML={{
            __html: newline2br(irregularity.irregularityType.instructions),
          }}
        />
        <Modal
          open={this.state.modalIsOpen}
          closeModal={this.onToggleModal}
          onConfirm={this.onCancelIrregularity}
          modalContent="irregularities.cancelModal"
          ariaHideApp={false}
        />
        <div className="buttons-container w-100">
          <button className="btn btn-warn w-50" onClick={this.props.onBack}>
            {this.props.t('common.labels.back')}
          </button>
          <button className="btn btn-warn w-50" onClick={this.onToggleModal}>
            {' '}
            {this.props.t('common.labels.cancel')}
          </button>
        </div>
        {!isEmpty(this.props.submitError) && (
          <AlertNotice
            message={
              this.props.submitError.message
                ? this.props.submitError.message
                : this.props.t('errors.somethingWentWrong')
            }
            type="error"
          />
        )}
        <div className="w-100">
          <button className="btn btn-action w-100 m-0" onClick={this.onSubmit}>
            {' '}
            {this.props.t('common.labels.submit')}
          </button>
        </div>
      </section>
    );
  }
}

IrregularityNotes.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  irregularity: PropTypes.shape({
    irregularityType: PropTypes.shape({}),
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(IrregularityNotes);
